import { Keys } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";
import { EnabledInTableHeaderValues } from "../../customTools/EnabledInTableHeader";

export class AdvancedSearchButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            enabledInTableHeader: EnabledInTableHeaderValues.ALWAYS,
            id: `${this.table.id}-tools-buttonAdvancedSearch`,
            variant: ButtonVariant.round,
            imageName: ImageName.documentSearch,
            hotkey: "Alt-S",
            onClick: () => this.table.crudManager.showSearch(),
            tooltip: "Show advanced search options (Alt-S)"
        });
        this.button.addHandlerForKey(Keys.S, { altKey: true });
        this.button.addHandlerForKey("ß".toUpperCase(), { altKey: true }); // Alt+s on Mac
    }
}
